import React, {useState} from 'react';
import { getCaseLabel, getCitationLabel } from "./lookupFunctions";
import { getCurrency } from "../config/utils";
import { dateIso2Us } from '../config/dateUtils';
import { useSxStyles    } from "../styles/sxStyles";
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery'
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import Grid2 from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip'
import Zoom from '@mui/material/Zoom'

const PartyListItem = (props) => {
    const partyRec = props.partyRec;
    const court = props.court;
    const selectParty = props.selectParty;
    const classes = useSxStyles;
    const theme = useTheme();
    const smallScreen = useMediaQuery(theme.breakpoints.down('lg'));
    const [open, setOpen] = useState(false);

    const buttonLabel = () => {
        return open ? 'Hide' : 'Expand';
    }

    return (
        (<ListItem alignItems='flex-start' sx={classes.listPadding}>
            <ListItemText
                sx={classes.listText}
                primary={
                    <Grid2
                        container
                        spacing={2}
                        alignItems="top"
                        sx={{width: '100%'}}
                    >
                        <Grid2
                            size={{
                                xs: 3,
                                lg: 2
                            }}>
                            <Tooltip title='Pay one or more balances for this party' arrow slots={{
                                transition: Zoom
                            }}>
                                <Button
                                    variant='contained'
                                    color='success'
                                    onClick={() => selectParty(partyRec)}
                                    sx={classes.tinyButton}
                                >
                                    Select
                                </Button>
                            </Tooltip>
                        </Grid2>
                        <Grid2
                            size={{
                                xs: 5,
                                lg: 5
                            }}>
                            {
                                partyRec.party.partyName ? partyRec.party.partyName :
                                    `${partyRec.party.lastName}, ${partyRec.party.firstName}`
                            }
                        </Grid2>
                        <Grid2
                            size={{
                                xs: 4,
                                lg: 3
                            }}>
                            {partyRec.party.dob ? dateIso2Us(partyRec.party.dob) : ''}
                        </Grid2>
                        <Grid2
                            size={{
                                xs: 12,
                                lg: 2
                            }}>
                            <Box component='span' sx={{display: 'flex', flexDirection: 'row-reverse'}}>
                                <Tooltip title='Show/hide the balances for this party' arrow slots={{
                                    transition: Zoom
                                }}>
                                    <Button
                                        variant='contained'
                                        onClick={() => setOpen(!open)}
                                        sx={classes.tinyButton}
                                    >
                                        {buttonLabel()}
                                    </Button>
                                </Tooltip>
                            </Box>
                        </Grid2>
                    </Grid2>
                }
                secondary={
                    <>
                        {partyRec.balances.map((balance) => {
                            return (
                                (<Collapse in={open} timeout='auto' unmountOnExit>
                                    <Grid2
                                        container
                                        spacing={2}
                                        alignItems="top"
                                        style={{width: '100%'}}
                                    >
                                        { !smallScreen &&
                                            <Grid2 size={{
                                                lg: 2
                                            }}>&nbsp;</Grid2>
                                        }
                                        <Grid2
                                            size={{
                                                xs: 6,
                                                lg: 5
                                            }}>
                                            {`${getCaseLabel(court)} ${balance.caseNumber}`}
                                        </Grid2>
                                        { balance.citationNumber ?
                                            <Grid2
                                                size={{
                                                    xs: 5,
                                                    lg: 3
                                                }}>
                                                {`${getCitationLabel(court)} ${balance.citationNumber}`}
                                            </Grid2>:
                                            <Grid2
                                                size={{
                                                    xs: 5,
                                                    lg: 3
                                                }}>
                                                &nbsp;
                                            </Grid2>
                                        }
                                        <Grid2
                                            size={{
                                                xs: 0,
                                                lg: 2
                                            }}>&nbsp;</Grid2>
                                        <Grid2
                                            size={{
                                                xs: 0,
                                                lg: 2
                                            }}>&nbsp;</Grid2>
                                        <Grid2
                                            style={{paddingTop: '0'}}
                                            size={{
                                                xs: 12,
                                                lg: 10
                                            }}>
                                            {balance.description}
                                        </Grid2>
                                        { !smallScreen &&
                                            <Grid2
                                                size={{
                                                    lg: 2
                                                }}>&nbsp;</Grid2>
                                        }
                                        <Grid2
                                            sx={{marginBottom: '.5rem'}}
                                            style={{paddingTop: '0'}}
                                            size={{
                                                xs: 6,
                                                lg: 5
                                            }}>
                                            {`Amount: ${getCurrency(balance.courtAmount)}`}
                                        </Grid2>
                                        <Grid2
                                            sx={{marginBottom: '.5rem'}}
                                            style={{paddingTop: '0'}}
                                            size={{
                                                xs: 5,
                                                lg: 3
                                            }}>
                                            {`Status: ${balance.ineligibleForPayment ? 'Not payable' : (balance.disposed ? 'Assessed' : 'Pending')}`}
                                        </Grid2>
                                    </Grid2>
                                </Collapse>)
                            );
                        })}
                    </>
                }
                slotProps={{
                    primary: {
                        component: 'span',
                        variant: 'subtitle1',
                        sx: classes.inline,
                        color: 'textPrimary'
                    },

                    secondary: {
                        component: 'span',
                        variant: 'body2',
                        sx: classes.inline,
                        color: 'textPrimary'
                    }
                }} />
        </ListItem>)
    );
}

export default PartyListItem;
